import { assetTypeToStrMap } from "@eave/shared/types/api";

const accountTypeOptions = Object.keys(assetTypeToStrMap).map(type => ({
  label: assetTypeToStrMap[type],
  value: type,
}));

export default accountTypeOptions;
